import React from 'react';
import { connect } from 'react-redux';

import WithUser from 'shared/HOCs/WithUser';

import {
  setPaymentStep,
  requestChangePlan
} from 'shared/components/ChangePlanModal/ducks';
import { PAYMENT_STEPS } from 'shared/components/ChangePlanModal/ducks';

import PremiumPlan from './PremiumPlan';
import EnterprisePlan from './EnterprisePlan';

import styles from './styles.module.scss';

class PlanTypes extends React.Component {
  handlePlanBtnClick = isCurrent => {
    if (isCurrent) {
      return;
    }

    const { setPaymentStep, processingSubscription } = this.props;

    if (processingSubscription) {
      return;
    }

    setPaymentStep(PAYMENT_STEPS.PROFILE_FORM);
  };

  render() {
    const { user, processingSubscription, premiumPlanPrice } = this.props;
    const planType = user ? user.plan_subscription.plan_type : null;

    return (
      <div className={styles.modalContent}>
        <div className={styles.headline}>
          Turbo charge your understanding of Real Estate and PropTech
        </div>
        <PremiumPlan
          currentPlanType={planType}
          handlePlanBtnClick={this.handlePlanBtnClick}
          processingSubscription={processingSubscription}
          price={premiumPlanPrice}
        />
        <EnterprisePlan />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    paymentStep,
    processingSubscription,
    premiumPlanPrice
  } = state.changePlan;

  return {
    paymentStep,
    processingSubscription,
    premiumPlanPrice
  };
};
const mapDispatchToProps = {
  setPaymentStep,
  requestChangePlan
};

export default WithUser(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PlanTypes)
);
